import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';

export type TabLabelKey =
    | 'sidebar.tabs.TEXT'
    | 'sidebar.tabs.INPUT'
    | 'sidebar.tabs.PHOTO'
    | 'sidebar.tabs.VIDEO'
    | 'sidebar.tabs.BUTTON'
    | 'sidebar.tabs.LIST'
    | 'sidebar.tabs.FORM'
    | 'sidebar.tabs.TABLE'
    | 'sidebar.tabs.FLIP_CARD_FRONT'
    | 'sidebar.tabs.FLIP_CARD_BACK'
    | 'sidebar.tabs.CONTENT'
    | 'sidebar.tabs.STYLE'
    | 'sidebar.tabs.ADVANCED';

export const TABS: Record<string, {id: string; label: TabLabelKey; properties: string[]}> = {
    TEXT: {id: 'text', label: 'sidebar.tabs.TEXT', properties: []},
    INPUT: {id: 'input', label: 'sidebar.tabs.INPUT', properties: ['label', 'placeholder', 'regex', 'regexErrorMessage']},
    PHOTO: {id: 'photo', label: 'sidebar.tabs.PHOTO', properties: []},
    VIDEO: {id: 'video', label: 'sidebar.tabs.VIDEO', properties: []},
    BUTTON: {id: 'button', label: 'sidebar.tabs.BUTTON', properties: ['text']},
    LIST: {id: 'list', label: 'sidebar.tabs.LIST', properties: []},
    FORM: {id: 'form', label: 'sidebar.tabs.FORM', properties: ['title', 'fieldElements']},
    TABLE: {id: 'table', label: 'sidebar.tabs.TABLE', properties: []},
    FLIP_CARD_FRONT: {id: 'flip_card_front', label: 'sidebar.tabs.FLIP_CARD_FRONT', properties: []},
    FLIP_CARD_BACK: {id: 'flip_card_back', label: 'sidebar.tabs.FLIP_CARD_BACK', properties: []},
    CONTENT: {
        id: 'content',
        label: 'sidebar.tabs.CONTENT',
        properties: [
            'question',
            'answers',
            'text',
            'imageSrc',
            'videoSrc',
            'buttonText',
            'buttonLink',
            'sequence',
            'leftElement',
            'rightElement',
            'pairs',
            'questions',
            'scale',
        ],
    },
    STYLE: {
        id: 'style',
        label: 'sidebar.tabs.STYLE',
        properties: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'borderRadius',
            'textColor',
            'fontSize',
            'fontFamily',
            'fontWeight',
            'textAlign',
            'padding',
            'margin',
        ],
    },
    ADVANCED: {
        id: 'advanced',
        label: 'sidebar.tabs.ADVANCED',
        properties: ['appearAfter', 'animationIn', 'slideChange', 'imageSrc', 'videoSrc', 'buttonText', 'buttonLink', 'borderRadius'],
    },
};

export type TabType = (typeof TABS)[keyof typeof TABS];

export const ELEMENT_TABS = {
    [ELEMENT.STATIC_TEXT]: [TABS.TEXT, TABS.ADVANCED],
    [ELEMENT.TEXT_INPUT]: [TABS.INPUT, TABS.ADVANCED],
    [ELEMENT.IMAGE]: [TABS.PHOTO, TABS.ADVANCED],
    [ELEMENT.VIDEO]: [TABS.VIDEO, TABS.ADVANCED],
    [ELEMENT.BUTTON]: [TABS.BUTTON, TABS.ADVANCED],
    [ELEMENT.STATIC_LIST]: [TABS.LIST, TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.FORM]: [TABS.FORM, TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.STATIC_TABLE_V2]: [TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.STATIC_TABLE]: [TABS.TABLE, TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.QUESTION]: [TABS.CONTENT, TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.YES_NO_QUESTION]: [TABS.CONTENT, TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.YES_NO_QUESTION_V2]: [TABS.CONTENT, TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.MULTI_SELECT]: [TABS.CONTENT, TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.PHOTO_ANSWER_QUESTION]: [TABS.CONTENT, TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.IMAGE_MARKUP]: [TABS.CONTENT, TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.SEQUENCE_QUESTION]: [TABS.CONTENT, TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.MATCH_PAIR_QUESTION]: [TABS.CONTENT, TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.QUESTION_REPORT]: [TABS.CONTENT, TABS.ADVANCED],
    [ELEMENT.LIKERT_SCALE]: [TABS.CONTENT, TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.CIRCLE]: [TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.ELLIPSE]: [TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.TRIANGLE]: [TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.STAR]: [TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.ARROW]: [TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.ARROW_V2]: [TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.LINE]: [TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.LINE_V2]: [TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.RECTANGLE]: [TABS.STYLE, TABS.ADVANCED],
    [ELEMENT.HTML]: [TABS.CONTENT, TABS.ADVANCED],
    [ELEMENT.MODAL]: [TABS.CONTENT, TABS.ADVANCED],
    [ELEMENT.IMAGE_GALLERY]: [TABS.CONTENT, TABS.ADVANCED],
    [ELEMENT.FLIP_CARD]: [TABS.FLIP_CARD_FRONT, TABS.FLIP_CARD_BACK, TABS.ADVANCED],
    [ELEMENT.CALCULATOR]: [TABS.CONTENT, TABS.ADVANCED],
    [ELEMENT.CHATBOT]: [TABS.CONTENT, TABS.ADVANCED],
} as Record<ELEMENT, TabType[]>;
